import { render, staticRenderFns } from "./MetricasGenerales.vue?vue&type=template&id=5cb0e15b&scoped=true"
import script from "./MetricasGenerales.vue?vue&type=script&lang=js"
export * from "./MetricasGenerales.vue?vue&type=script&lang=js"
import style0 from "./MetricasGenerales.vue?vue&type=style&index=0&id=5cb0e15b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0e15b",
  null
  
)

export default component.exports